
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headerColors: [],
      rowColors: [],
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok.background

      return styles
    },
    // tableHeaderStyles() {
    //   const styles = {}

    //   styles.background = this.blok.headerBackgroundColor

    //   return styles
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.headerColors = this.parseTableRowColors(
        this.blok.headerBackgroundColor
      )
      this.rowColors = this.parseTableRowColors(this.blok.rowBackgroundColors)
      this.animate()
    })
  },
  methods: {
    animate() {
      const mm = this.$gsap.matchMedia(this.$refs.container)

      mm.add('(min-width: 1024px)', () => {
        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // markers: true,
            start: 'top 90%',
            end: 'bottom 20%',
            toggleActions: 'restart none none reverse',
          },
        })

        tl.from(
          '.box',
          {
            opacity: 0,
            y: -10,
            scale: 0.8,
            // stagger: 0.1,
            duration: 0.3,
            stagger: {
              // grid: [7, 15],
              from: 'start',
              axis: null,
              amount: 0.2,
            },
          },
          0
        )
      })
    },
    // convert string of colors to array
    parseTableRowColors(str) {
      return str?.replace(/(\r\n|\n|\r)/gm, '').split('/') || []
    },
  },
}
